import { render, staticRenderFns } from "./FormLegal.vue?vue&type=template&id=f767bb32&"
import script from "./FormLegal.vue?vue&type=script&lang=js&"
export * from "./FormLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports